import React, { useState, useContext, useEffect } from "react";
import { Col, Container, Row, Button } from "reactstrap";
import Sidebar from "./layout/sidebar/Sidebar";
import * as signalR from "@microsoft/signalr";
import { useAlert } from "react-alert";
import { Link } from "react-router-dom";
import { IoHome } from "react-icons/io5";
import { TiWeatherPartlySunny } from "react-icons/ti";
import { FaUserFriends } from "react-icons/fa";
import { MdOutlineSettingsSuggest } from "react-icons/md";
import { FaUser } from "react-icons/fa";
import { IoMdLogOut } from "react-icons/io";
import { GiHamburgerMenu } from "react-icons/gi";
import { AiOutlineClose } from "react-icons/ai";
import logo from "../assets/img/Needle_logo.png";
import { AuthContext } from "../context/authContext";
import { useLoadingMessage } from "./useLoadingMessage";

type Props = {
  active: string;
  children?: JSX.Element | JSX.Element[];
};

const Layout: React.FC<Props> = ({ active, children }) => {
  const { role, logout, user } = useContext(AuthContext);
  const [report, setReport] = useState("");
  const alert = useAlert();
  const { activeBar, isLoading } = useLoadingMessage();
  const [showMenu, setShowMenu] = useState(false);
  
  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  // Ensure menu closes when switching to mobile view
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && showMenu) {
        setShowMenu(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [showMenu]);

  return (
    <React.Fragment>
      <div className="real">
        <div
          className="sidebar-toggle shadow"
          id="m-tog"
          onClick={toggleMenu}
        >
          <div className="py-1 px-2 text-white h3">
            <GiHamburgerMenu />
          </div>
        </div>
        <div className="cont-div">
          <aside
            className="sidebar"
            style={{ left: showMenu ? "-0px" : "-280px" }}
          >
            <div className="logo-section bg-white text-center pt-4">
              <img src={logo} width="60%" alt="logo" />
            </div>
            
            {role === "Warehouse Manager" ? (
              <>
                <Link
                  to="/warehousemanagerdashboard"
                  className={active === "WarehouseManagerDashboard" ? "active-m" : ""}
                >
                  <span className="">
                    <IoHome className="dash-icon" />
                  </span>
                  Dashboard
                </Link>
                <Link
                  to="/warehousemanager"
                  className={active === "WarehouseManagerComponent" ? "active-m" : ""}
                >
                  <span className="">
                    <TiWeatherPartlySunny className="dash-icon" />
                  </span>{" "}
                  Warehouse
                </Link>
              </>
            ) : (
              <>
                <Link
                  to="/dashboard"
                  className={active === "Dashboard" ? "active-m" : ""}
                >
                  <span className="">
                    <IoHome className="dash-icon" />
                  </span>
                  Dashboard
                </Link>
                <Link
                  to="/season"
                  className={active === "Seasons" ? "active-m" : ""}
                >
                  <span className="">
                    <TiWeatherPartlySunny className="dash-icon" />
                  </span>{" "}
                  Season
                </Link>
                <Link 
                  to="/users" 
                  className={active === "Users" ? "active-m" : ""}
                >
                  <span className="">
                    <FaUserFriends className="dash-icon" />
                  </span>{" "}
                  User
                </Link>
                <Link
                  to="/config"
                  className={active === "Config" ? "active-m" : ""}
                >
                  <span className="">
                    <MdOutlineSettingsSuggest className="dash-icon" />
                  </span>{" "}
                  Config
                </Link>
              </>
            )}
            <div className="logout-div mb-5">
              <span className="admin-span text-white font-weight-bold">
                <FaUser className="admin-icon" />
                <small> {role || "User"}</small>
              </span>
              <Button onClick={logout} className="logout-btn shadow border-0">
                Logout
              </Button>
            </div>
          </aside>
        </div>

        <main className="content">
          {report && <h6>{report}</h6>}
          {children}
        </main>
      </div>
    </React.Fragment>
  );
};

export default Layout;
